/**
 * @module productCatalogCardThumbnailGallery
 */
;(function productCatalogCardThumbnailGallery() {
    function productCatalogCardThumbnailGallery($dom) {
        /**
         * // local object availability
         * @private
         */
        var _this = this

        /**
         * @method thumbnailsInteraction
         * @returns {undefined}
         */
        this.thumbnailsInteraction = function () {
            var $items = $dom.find('.js-color-preview')

            $items.on('mouseenter click', function (event) {
                // prevent event bubbling.
                event.preventDefault()
                _this.previewItem(this)
            })
            $items.on('mouseleave', function (event) {
                // prevent event bubbling.
                event.preventDefault()
                _this.previewItem($items.first(), false)
            })

            $items.first().addClass('active')
        }

        /**
         * @method previewItem by given item color
         * @param item {HTMLElement} the item which should be previewed
         * @param showCaption {boolean} show caption within preview image
         * @returns {undefined}
         */
        this.previewItem = function (item, showCaption = true) {
            var $hoverItem = $(item)
            $hoverItem.addClass('active')

            var $previewContainer = $dom.find('.js-image-preview-container')

            // build preview image src
            var $previewImageSrc = $hoverItem.attr('data-image-large')
            var $previewFigcaptionText = ''

            // only show caption if its desired
            if (showCaption === true) {
                $previewFigcaptionText = $hoverItem.attr('data-figcaption')
            }

            if ($previewImageSrc === 'undefined' || $previewImageSrc === null) {
                console.error('no image resource available')
            } else {
                $previewContainer.find('img').attr('src', $previewImageSrc)
                $previewContainer.find('figcaption').text($previewFigcaptionText)
            }
        }

        /**
         * @method showMoreThumbnails
         * @returns {undefined}
         */
        this.showMoreThumbnails = function () {
            var $showMoreButton = $dom.find('.js-show-more-color-text-button')
            var $catalogColorPreviewsElement = $dom.find('.js-product-catalog--color-previews')

            if ($showMoreButton.length) {
                $showMoreButton.on('click', function (event) {
                    // prevent event bubbling.
                    event.preventDefault()

                    $(this).toggleClass('active')
                    $catalogColorPreviewsElement.toggleClass('hide-extra-child-items active')
                })
            }
        }

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.thumbnailsInteraction()
            _this.showMoreThumbnails()
        }

        /**
         * initialize call
         */
        _this.init()
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }

    window.Creaton.productCatalogCardThumbnailGallery = productCatalogCardThumbnailGallery
})()
